import * as PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "../../messages/messages";

const useStyles = makeStyles(theme => ({
  wrapper: {
    borderRadius: "15px",
    border: `1px solid black`,
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  header: {
    borderBottom: "1px solid black",
    padding: theme.spacing(0),
    textAlign: "center",
  },
  data: {
    fontWeight: "bold",
  },
  labels: {
    fontSize: "12px",
  },
  content: {
    padding: theme.spacing(2),
  },
  buttonContainer: {
    borderTop: "1px solid rgba(0,0,0,0.3)",
    padding: theme.spacing(1, 0),
    margin: theme.spacing(0, 2),
    textAlign: "right",
  },
  roundedButton: {
    borderRadius: "50px",
    border: "1px solid black",
  },
}));
function PatientDataBoxNew({
  patient = {},
  dentists = [],
  insurers = [],
  productQuestions = {},
  onClickView,
}) {
  const classes = useStyles();

  const insurer = insurers.find(i => i.id === patient.careId);
  const dentist = dentists.find(d => d.id === patient.dentistId);

  return (
    <div className={classes.wrapper} data-cy="patientBox">
      <div className={classes.header}>
        <Typography variant="h6">
          <FormattedMessage {...GlobalMessages.patient} />
        </Typography>
      </div>
      <Grid container justify="space-between" className={classes.content}>
        <Grid item xs="auto">
          <Typography className={classes.labels}>
            <FormattedMessage {...GlobalMessages.patientName} />
          </Typography>
          <Typography className={classes.data}>{patient.name}</Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography className={classes.labels}>
            <FormattedMessage {...GlobalMessages.internal_ref} />
          </Typography>
          <Typography className={classes.data}>
            {patient.internalRef}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography className={classes.labels}>
            <FormattedMessage {...GlobalMessages.insurer} />
          </Typography>
          {insurer ? (
            <Typography className={classes.data}>{insurer.name} </Typography>
          ) : (
            <Typography className={classes.data}>
              <FormattedMessage {...GlobalMessages.other} />
            </Typography>
          )}
        </Grid>
        <Grid item xs="auto">
          <Typography className={classes.labels}>
            <FormattedMessage {...GlobalMessages.insuranceNumber} />
          </Typography>
          {patient.insuranceNumber ? (
            <Typography className={classes.data}>
              {patient.insuranceNumber}
            </Typography>
          ) : (
            <Typography className={classes.data}>
              <FormattedMessage {...GlobalMessages.notApplicableShort} />
            </Typography>
          )}
        </Grid>
        <Grid item xs="auto">
          <Typography className={classes.labels}>
            <FormattedMessage {...GlobalMessages.dentist} />
          </Typography>
          {dentist ? (
            <Typography className={classes.data}>{dentist.name} </Typography>
          ) : (
            <Typography className={classes.data}>
              <FormattedMessage {...GlobalMessages.other} />
            </Typography>
          )}
        </Grid>
        {productQuestions &&
          (productQuestions.upperProductName ||
            productQuestions.lowerProductName) && (
            <>
              <Grid item xs="auto" data-cy="upperJawLabel">
                <Typography className={classes.labels}>
                  <FormattedMessage {...GlobalMessages.orderUpperJaw} />
                </Typography>
                <Typography className={classes.data}>
                  {productQuestions.upperProductName}
                </Typography>
              </Grid>
              <Grid item xs="auto" data-cy="lowerJawLabel">
                <Typography className={classes.labels}>
                  <FormattedMessage {...GlobalMessages.orderLowerJaw} />
                </Typography>
                <Typography className={classes.data}>
                  {productQuestions.lowerProductName}
                </Typography>
              </Grid>
            </>
          )}
      </Grid>
      {onClickView && (
        <div className={classes.buttonContainer}>
          <Button
            size="small"
            className={classes.roundedButton}
            variant="outlined"
            onClick={() => {
              onClickView(patient);
            }}
          >
            <FormattedMessage {...GlobalMessages.viewEditPatient} />
          </Button>
        </div>
      )}
    </div>
  );
}

PatientDataBoxNew.propTypes = {
  patient: PropTypes.object,
  dentists: PropTypes.array,
  insurers: PropTypes.array,
  productQuestions: PropTypes.object,
  onClickView: PropTypes.func,
};

export default PatientDataBoxNew;
